export default "__VITE_ASSET__CEe7dPJy__"